export default __webpack_public_path__ + "static/media/vikki.e1b13b4a.wav";